export enum MessageGroup {

    ForFromTelephone = '+918145073532',
    FormEmail='asc.dentApp@gmail.com'
}